export enum LicentieRol {
	SCHOOLBREEDTEAM = 'schoolbreedTeam',
	SECTIE = 'sectie',
	DOCENTMENTOR = 'docentMentor',
	AANWEZIGHEID = 'aanwezigheid',
	BESTUUR = 'bestuur',
	BESTUURTOTAAL = 'bestuurTotaal',
}
